const hostnameMatcher = /^([\w-]+\.)*landr\.com$/;

export const isLandrAppHostname = (hostname: string): boolean => {
    return hostnameMatcher.test(hostname);
};
